import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialMonitoringState: Dtos.Monitoring & IRegistrationFormState = {
    id: null,
    trialInstitutionId: null,
    trialInstitution: null,
    startDate: null,
    endDate: null,
    monitors: null,
    monitoringVisitTypeId: null,
    monitoringVisitType: null,
    monitoringPharmacyVisitId: null,
    monitoringPharmacyVisit: null,
    monitoringMeetingId: null,
    monitoringMeeting: null,
    hoursMonitoring: null,
    minorDeviations: null,
    submittedTo: null,
    submittedDate: null,
    monitoringStatusId: null,
    monitoringStatus: null,
    approvedDate: null,
    mailedDate: null,
    mailedNa: null,
    comments: null,
    uploadedDate: null,
    uploadedNa: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,

    monitoringIssues: [],
    monitoringDocuments: []
}

export interface IMonitoringReduxFormState {
    id: IFieldState<number>,
    trialInstitutionId: IFieldState<number>,
    trialInstitution: IFieldState<Dtos.TrialInstitution>,
    startDate: IFieldState<string>,
    endDate: IFieldState<string>,
    monitors: IFieldState<string>,
    monitoringVisitTypeId: IFieldState<number>,
    monitoringVisitType: IFieldState<Dtos.MonitoringVisitType>,
    monitoringPharmacyVisitId: IFieldState<number>,
    monitoringPharmacyVisit: IFieldState<Dtos.MonitoringPharmacyVisit>,
    monitoringMeetingId: IFieldState<number>,
    monitoringMeeting: IFieldState<Dtos.MonitoringMeeting>,
    hoursMonitoring: IFieldState<number>,
    minorDeviations: IFieldState<number>,
    submittedTo: IFieldState<string>,
    submittedDate: IFieldState<string>,
    monitoringStatusId: IFieldState<number>,
    monitoringStatus: IFieldState<Dtos.MonitoringStatus>,
    approvedDate: IFieldState<string>,
    mailedDate: IFieldState<string>,
    mailedNa: IFieldState<boolean>,
    comments: IFieldState<string>,
    uploadedDate: IFieldState<string>,
    uploadedNa: IFieldState<boolean>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>,

    monitoringIssues: IFieldState<Dtos.MonitoringIssue[]>
    monitoringDocuments: IFieldState<Dtos.MonitoringDocument[]>
}
